import Header from "../components/Header";
import React from "react";
import Footer from "./Footer";
import JChhatwalImg from "../images/JChhatwal.jpg";
import TAyerImg from "../images/TAyer.png";
import AElHabrImg from "../images/AElHabr.jpg";
import DBaltaImg from "../images/DBalta.jpg";
import AMarsiImg from "../images/AMasri.jpg";
import NDesaiImg from "../images/NDesai.jpg";
import TAbrahamImg from "../images/TAbraham.jpg";
import RRielloImg from "../images/RRiello.jpg";
import AOwensImg from "../images/AOwens.jpg";
import MButznerImg from "../images/MButzner.jpg";
import SShreayImg from "../images/SShreay.jpg";
import KFarajkhahImg from "../images/KFarajkhah.png";
import IKocakImg from "../images/IKocak.png";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";
import {useEffect} from "react";
import TeamCard from "../components/TeamCard";

const Team: React.FC = () => {
  const location = useLocation();

  const team = [
    {
      name: "Nihar R. Desai, MD, MPH",
      text: "Associate Professor of Medicine, Vice Chief, Section of Cardiovascular Medicine, Yale University School of Medicine, Investigator, Center for Outcomes Research and Evaluation, Executive Director, Bundled Payments and Clinical Service Line Operations, Yale New Haven Health System",
      img: NDesaiImg,
    },
    {
      name: "Ralph J. Riello III, PharmD, BCPS",
      text: "Assistant Professor (Nephrology), Yale University School of Medicine, Clinical Pharmacy Specialist, Clinical & Translational Research",
      img: RRielloImg,
    },
    {
      name: "Ahmad Masri, MD, MS",
      text: "Associate Professor of Medicine, Division of Cardiovascular Medicine, School of Medicine Cardiomyopathy Section Head, Director, Hypertrophic Cardiomyopathy Center Oregon Health and Sciences University",
      img: AMarsiImg,
    },
    {
      name: "Anjali Tiku Owens, MD",
      text: "Associate Professor of Medicine (Cardiovascular Medicine) Attending Cardiologist, Heart Failure and Transplantation Hospital of the University of Pennsylvania Director, Penn Familial Cardiomyopathy Program Director, Hypertrophic Cardiomyopathy Clinic Director, Penn Center for Inherited Cardiovascular Disease University of Pennsylvania",
      img: AOwensImg,
    },
    {
      name: "Theodore Abraham, MD",
      text: "Meyer Friedman Distinguished Professor of Medicine Co-Director, HCM Center of Excellence University of California, San Francisco Chief Medical Officer, UCSF Health Care Network",
      img: TAbrahamImg,
    },
    {
      name: "Mike Butzner, DrPH, MPH",
      text: "Associate Director, Health Economics and Outcomes Research Cytokinetics, Inc.",
      img: MButznerImg,
    },
    {
      name: "Sanatan Shreay, PhD, MS",
      text: "Executive Director, Head of Health Economics and Outcomes Research Cytokinetics, Inc.",
      img: SShreayImg,
    },
    {
      name: "Jag Chhatwal, PhD",
      text: "Associate Professor, Harvard Medical School Director, Massachusetts General Hospital (MHG) Institute for Technology Assessment",
      img: JChhatwalImg,
    },
    {
      name: "Turgay Ayer, PhD",
      text: "Virginia C. and Joseph C. Mello Chaired Professor, Department of Industrial and Systems Engineering Georgia Institute of Technology",
      img: TAyerImg,
    },
    {
      name: "Andrew ElHabr, PhD",
      text: "Associate Director, Real-World Evidence & Data Analytics Value Analytics Labs",
      img: AElHabrImg,
    },
    {
      name: "Kian Farajkhah, PhD",
      text: "Data Scientist, Real-World Evidence & Data Analytics Value Analytics Labs",
      img: KFarajkhahImg,
    },
    {
      name: "Deniz Balta, BS",
      text: "Software Engineer, Software Solutions Value Analytics Labs",
      img: DBaltaImg,
    },
    {
      name: "Irem B. Kocak, MS",
      text: "Data Scientist, Real-World Evidence & Data Analytics Value Analytics Labs",
      img: IKocakImg,
    },
  ];

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <div className="bg-white flex flex-col min-h-screen">
      <Header />
      <div className="w-[90%] mx-auto flex-grow">
        <div className="font-bold lg:text-[40px] md:text-[34px] text-[28px] text-valmidnight">
          Team
        </div>
        <div className="grid lg:grid-cols-2 gap-x-8 gap-y-8">
          {team.map((member, i) => (
            <TeamCard
              key={i}
              title={member.name}
              text={member.text}
              img={member.img}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Team;
